// Task Details View
// Tagging For Git

import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { ConfirmEventType, ConfirmationService, Message, MessageService } from 'primeng/api';
import { stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';


import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-task-detail-view',
  templateUrl: './task-detail-view.component.html',
  styleUrls: ['./task-detail-view.component.scss'],
  providers: [MessageService]
})
export class TaskDetailViewComponent implements OnInit{

  filterRequestData!: any;
  
  messages: Message[] = [];
  
  status: any;

  spinner = false;
  // reCreate = false;
  allowedRight = ['Ministries/Entities', 'Organisational Units', 'Branches']
  translator:TranslatorPipe = new TranslatorPipe()


//ou
  filteredData: any;
  selectionData: any;
  fieldModal = false;
  fieldData: string = '';
  treeData: any[] = [];
  searchText: string = '';
   //filters
   typeFilter: any = undefined;
   oufilter: any = undefined;

   stats: stat[] = [
    { name: this.translate('active'), number: 84, icon: 'pi pi-check-circle' },
    { name: this.translate('Inactive'), number: 2, icon: 'pi pi-times-circle' },
  ];

  staticURL = GlobalConstants.staticFilesURL;
  selectedDate: Date | any = new Date();
  filteredStartDate!: Date;
  filteredEndDate!: Date;
  data: any;
  trainingRequestData!: any[];

  statusCounts: { [status: string]: number } = {};
  
  statusOptions: any[] = [
    { name: this.translate('pending'), value: 'PENDING' },
    { name: this.translate('Accepted'), value: 'APPROVED' },
    { name: this.translate('Draft'), value: 'TRAINING_CREATED' },
    { name: this.translate('Rejected'), value: 'REJECTED' },
    { name: this.translate('Published'), value: 'PUBLISHED' },
    { name: this.translate('completed'), value: 'COMPLETED' },
   
  ];

  selected = 'WEEKLY'

  tabs: any[] = [
    { name: this.translate('weekly'), value: 'WEEKLY' },
    { name: this.translate('Consolidated'), value: 'MONTHLY' }
  ];

  rejectData = {
    _id: null,
    reason: null,
    status : ''
  };
  reasonError: any;
  rejectReason: any;
  requestHolder: any;

  createCourseModal: boolean = false;
  openCourseModal: boolean = false;
  fromCreateTraining: boolean = false;
  openAddKLModal = false
  selectKLCourse : any
  trainingDetails: any;
  permissions: any;
  managerOu :any

 
  managerPage : boolean = false;

  page: number = 1;
  rows: number = 10;
  first = 1;
  totalTraining: number = 0;
  allData: any;

  ShowDashboard : boolean = false
  showCalender : boolean = false

  constructor(
    private dataService: DataService,
    public permissionService: PermissionHandlerService,
    private orgUnits: OrgUnitsService,
    private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,) { }

  ngOnInit() {

    this.managerOu = localStorage.getItem('managerOus');
    this.managerOu = this.managerOu ? JSON.parse(this.managerOu) : null
    // if(this.managerOu && this.managerOu.length > 0){
    //   this.managerPage = true
    //   this.ShowDashboard = false
    // }
    // else {
    // }
    this.ShowDashboard = false
    this.statusOptions.push({ name: this.translate('DEACTIVATED'), value: 'DEACTIVATED' })

    //super permission
    if(this.hasPermission('CONTINUOUS_TRAINING_DASHBOARD', 'a')){
      this.ShowDashboard = true
    }

    this.getTrainingTypes().then(()=>{
      this.getTrainingRequests();
    })
    this.getTreeData();
  }

  changeRoute(route:any){
    this.router.navigate([route]);

  }
  
  onPageChange(event: PageEvent) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1
    this.getTrainingRequests();
}

  getClasses(data : any) {
    if (!this.managerPage) {
      return data
    }
   else return ''
  }

  

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }


  

async  filter(){
  this.status = undefined;
  this.first = 0
    // Date Checks
    if( this.selected == 'WEEKLY'){
      this.selectedDate = new Date();
    } else {
      this.selectedDate = undefined
    }


   await this.getTrainingRequests();

    this.selected == 'WEEKLY' ? null : this.filterByMonth();
    this.status = undefined;
    
  }

  trainingType : any
  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });
   
    if (res.error) {
      return;
    }
    this.trainingType = res.data.map((item: any) => {
   return {
        _id: item._id,
        label: item.arabic,
        allowed_ou : item.allowed_ou,
        name : item.name,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      }; 
    });
  }




  hasPermission(unit:string,flag:string){
    return this.permissionService.hasPermission(unit, flag)
  }

  refreshFilters(){
    this.first = 0
    console.log("FIlter Refreshed");
    this.status = undefined;
    this.oufilter = undefined
    this.selectedDate = new Date()
    this.getTrainingRequests();
  }


  //   Monthly filter
  filterByMonth() {
    if (this.selectedDate) {
      let  selectedMonthDate = new Date(this.selectedDate);
      const year = selectedMonthDate.getFullYear();
      this.filterRequestData = this.trainingRequestData.filter((record:any) => record.date?.year == year && record.type?.name == 'Unified session');
      this.countStatusOccurrences();
    }
  }


   //get all training requests
   getTrainingRequests = async () => {
    try {

      this.statusCounts = {}
      
      let query : any = { status : this.status}
      
      if(this.selectedDate && this.selected == 'WEEKLY' ){
        
        let type  = this.trainingType.find((item:any)=> item.name == this.selected)
        query.type = type._id;
       
        let tempData : Date = cloneDeep(this.selectedDate)
       
        // Set the start of the week to the previous Friday
          const startOfWeek = new Date(tempData);
          startOfWeek.setHours(0, 0, 0, 0);
          startOfWeek.setDate(tempData.getDate() - (tempData.getDay() + 2) % 7);

          // Set the end of the week to the next Thursday
          const endOftheWeek = new Date(startOfWeek);
          endOftheWeek.setDate(startOfWeek.getDate() + 6);

          endOftheWeek.setHours(23, 59, 59, 0);

        query.createdAt = {
          $gte: this.orgUnits.getTimeForRequest(startOfWeek),
          $lt: this.orgUnits.getTimeForRequest(endOftheWeek)
        }

      } else {
        let type  = this.trainingType.find((item:any)=> item.name == 'Unified session')
        query.type = type._id;
      }
     
      if(this.oufilter){
       query.ou = this.oufilter._id
      }
      

      if(this.status == "COMPLETED"){
        query.status = 'PUBLISHED'
      }

      if(this.status == "DEACTIVATED"){
       delete query.status
        query.active = false
      }

      this.spinner = true
      
      this.trainingRequestData = [];


      if(this.hasPermission('CONTINUOUS_TRAINING', 'r') && !this.hasPermission('CONTINUOUS_TRAINING_REQUEST', 'r') ){
        query.ou = { $in: this.managerOu } 
        query.active = true
      }

      if(this.hasPermission('CONTINUOUS_TRAINING_REQUEST', 'c')){
        delete query.ou
      }

      
      let res = await this.dataService.postData(`training-req/get?offset=${this.rows}&page=${this.page}`, query);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      //Check for inactive
      let updatedArray =  res?.data?.data.map((obj:any) => {
        if (obj.active == false) {
          return { ...obj, status: "DEACTIVATED" };
        }
        return obj; 
      });

      //Check for completed
      const currentDate = new Date();
      // Loop through the array and update the status
      updatedArray = updatedArray.map((obj:any) => {
        // Parse the "end_date" from each object
        const endDate = new Date(obj?.trainingId?.end_date);
        // Compare with the current date
        if (endDate < currentDate && obj.status == 'PUBLISHED') {
          // Update the "status" to "COMPLETED"
          return { ...obj, status: "COMPLETED" };
        }
        return obj; // If the end_date has not passed, return the object as is
      });


      //removing that are not completed
      if(this.status == "COMPLETED"){
        updatedArray = updatedArray.filter((obj:any) => obj.status == "COMPLETED");
      }

      this.trainingRequestData = [...updatedArray];

      console.log("6534f315523a094a4005b6cc====>",this.trainingRequestData);

      this.filterRequestData = this.trainingRequestData;
      this.totalTraining =  res?.data?.totalCount;
      this.spinner = false
      this.selected == 'WEEKLY' ? null : this.filterByMonth();
    } catch (error) {
      console.log(error);
    }
  };

  //Get tree data and as per the  permission
  async getTreeData() {
    this.treeData = await this.orgUnits.getOrgUnitsWithTagsFilter(this.allowedRight);
  }


   //Function to get common fields of the selected data
   filterData(data: any, key: any, value: any) {
    let results: any = [];

    //Base Recursive Function
    function recursiveFilter(obj: any, parentObj = null) {
      if (Array.isArray(obj)) {
        obj.forEach((item) => recursiveFilter(item, parentObj));
      } else if (typeof obj === 'object') {
        if (obj != null && obj.hasOwnProperty(key) && obj[key] === value) {
          if (parentObj) {
            results.push(parentObj);
          }
          results.push(obj);
        }
        if (obj != null && obj != undefined)
          Object.values(obj).forEach((value) => recursiveFilter(value, obj));
      }
    }

    recursiveFilter(data);
    return results;
  }


  private updateTypeCounts(): void {
    if (this.typeFilter || this.oufilter || this.filteredData) {
      let activeCount = this.filteredData.filter((e: any) => e.active === true).length;
      let inactiveCount = this.filteredData.length - activeCount;
      this.stats = [
        { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
        { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
      ];
    }
  }

  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }


  publish(id :any) {
    console.log("Published Called ==");
    this.rejectData._id = id
    this.rejectData.status = 'PUBLISHED'
      this.confirm({
        message: this.translate('Are you sure you want to pusblish this training'),
        header: this.translate('Comfirm message heading'),
        icon: 'pi pi-exclamation-triangle',
        action: () => this.deactivateInit(),
      });

  }



  approve(id :any) {
    // confirm modal lagan h
    this.rejectData._id = id
    this.rejectData.status = 'APPROVED'
      this.confirm({
      message: this.translate('Are you sure you want to Accept this training?'),
      header:  this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: () => this.deactivateInit(),
      });

  }


  changeActivation(id :any , status:boolean) {
    // confirm modal lagan h
    this.rejectData._id = id
    this.rejectData.status = 'APPROVED'
    

   let message = this.translate('Are you sure you want to publish this training?')
    if(status){
      message =  this.translate('Are you sure you want to activate this training?')
    } else {
      message = this.translate('Are you sure you want to diactivate this task?')
    }
      this.confirm({ 
        message: message,
      header:   this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: () => this.activateDeactivate(id, status),
      });

  }

  deleteRequest(id : string){
    this.confirm({
       message: this.translate('Are you sure you want to delete this request?'),
    header:  this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteRequestAPI(id),
    });
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }


  async deleteRequestAPI(id : string){
    try {
      let res = await this.dataService.deleteData('training-req/'+id);
      if(!res.error){
        this.getTrainingRequests();
        }
    } catch (error) {
      console.log(error)
    }  

  }



  async activateDeactivate( id : string , status : boolean){
    try {
      const data = {
        _id : id,
        active : status
      }
      let res = await this.dataService.postData('training-req/',data,'PUT',false);
      if(!res.error){

        this.refreshFilters()
        this.getTrainingRequests();
      } else {
        this.reasonError = res.msg;
      }
    } catch (error) {
      console.log(error)
    }  

  }


  async deactivateInit(){
    try {
      if (this.rejectData.reason == undefined && this.rejectData.status != 'APPROVED' && this.rejectData.status != 'PUBLISHED' && this.rejectData.status != 'TRAINING_CREATED') {
        this.reasonError = this.translate("Reason Required");
        return;
      }
      this.reasonError = undefined;
      let res = await this.dataService.postData('training-req/',this.rejectData,'PUT',false);
      if(!res.error){
        this.rejectReason = false
        this.rejectData = {
          _id: null,
          reason: null,
          status : ''
        };
        this.refreshFilters();
        this.getTrainingRequests();
        
      } else {
        this.reasonError = res.msg;
      }

    } catch (error) {
      console.log(error)
    }  

  }
  

  countStatusOccurrences() {
    this.filterRequestData.forEach((item : any) => {
      const status = item.status;
      if (this.statusCounts[status]) {
        this.statusCounts[status]++;
      } else {
        this.statusCounts[status] = 1;
      }
    });
  }

  openCourse(req:any, view?:boolean){
    try {

      let parems = {
        _id : req.trainingId._id,
        // flag : view ? 'VIEW' : 'EDIT', 
        from : this.managerPage ? 'Manager' : 'SBC'
      }
      

      this.navigateToTrainingPage(parems)

      // this.createCourseModal = false;
      // this.openCourseModal = true;
      // view ? req.view = true : req.view = false;
      // this.permissions = req;
      // let res = await this.dataService.getData('course/'+req._id);
      // if(res.error){
      //   return
      // }  
      // this.trainingDetails = res.data[0]
    } catch (error) {
      console.log(error);
    }
  }

  navigateToTrainingPage(params:any) {
    const trainingId = params._id;
    
    this.router.navigate(['/training/training-page', trainingId], { queryParams: params } );
  }


  // Add Users
  usersInCourse : any = []
  course : any 
  addTrainer : boolean = false
getUserQuery : any
  addAttendees(courseData: any) {
    this.usersInCourse = [...courseData.trainingId.attendees];
    this.course = courseData
    this.addTrainer = true

    if(this.course.type.name == 'WEEKLY'){
      this.getUserQuery = { ous: [this.course?.ou?._id], training: this.course._id }
    }
    else {
      this.getUserQuery = { ous: this.course?.ous, training: this.course._id }
    }


    this.getUserQuery
    

  }

  async assNewTrainers(users: any) {
    if (users.emit == false || users.emit == true) {
      this.addTrainer = false
    }

    let data = {
      _id: this.course._id,
      attendees: users.users.map((e: any) => e._id),
      assignAll : true
    }

    await this.assAttendees(data);

  }

  async assAttendees(data: any) {
    try {

      let res = await this.dataService.postData('course/assign-attendees', data, 'PUT', false);
      if (!res.error) {
        this.getTrainingRequests();
        return
      } else {
       return
      }
    } catch (error) {
      console.log(error)
    }

  }

  isWeekPassed(value: Date): boolean {
    // Get current date
    const currentDate = new Date();

    // Get the day of the week (0 for Sunday, 1 for Monday, ..., 6 for Saturday) for createdAt
    const createdAt = new Date(value);
    const createdAtDayOfWeek = createdAt.getDay();

    // Adjust createdAt if it's Friday (5)
    if (createdAtDayOfWeek === 5) { // Friday
        createdAt.setDate(createdAt.getDate() + 1); // Add 1 day
    }

    if (createdAtDayOfWeek === 6) { // Friday
      createdAt.setDate(createdAt.getDate() + 2); // Add 1 day
  }

    // Adjust current date to the start of the week (Sunday)
    const startOfWeek = new Date(createdAt);
    startOfWeek.setDate(createdAt.getDate() - createdAt.getDay());

    // Adjust current date to the end of the week (Saturday)
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    // Check if adjusted createdAt date is after the end of the current week
    if (currentDate > endOfWeek) {
        return false; // Week has passed
    }
    else  return true; // Week has not passed
}

  showRejectButton(request : any){
    request


    let week = this.isWeekPassed(request.createdAt)

    if(request.type.name == 'WEEKLY' && week && !request.reason){
      return true
    }
    else  return false
  }


  librarySubmit(event:any){
    this.openAddKLModal = false
}
  


  
  


}


interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}